<template>
  <div class="commodity-tb-cont">
    <div
      class="commodity-tb-item"
      @click="handleOpenPage(item,index+1)"
      v-for="(item, index) in goodsList"
      :key="index"
      :style="{'marginBottom': isFree ? '0.62rem' : ''}"
    >
      <!-- <div class="commodity-tb-img"
        :style="{
          'background': 'url('+ item.pic + ') no-repeat center center',
          'background-size': 'cover',
        }">
      </div> -->
      <div class="commodity-tb-box">
        <img :src="item.pic" alt="" class="commodity-tb-img">
        <div class="apply-btn" v-if="isFree">
          <span>马上学习</span>
          <img src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659693171602.png" alt="">
        </div>
      </div>
      <!-- <div class="apply-btn" v-if="isFree">
        <span>马上学习</span>
        <img src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659693171602.png" alt="">
      </div> -->
      <div class="commodity-tb-item-text" :style="{'marginTop': isFree ? '0.48rem' : ''}">
        <div class="commodity-tb-item-title ellipsis">{{item.name}}</div>
        <span class="salePrice" v-if="!isFree">￥{{item.price}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'commodityTb',
  props: {
    goodsList: {
      type: Array,
      default: ()=>[]
    },
    isFree: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    filterStr(val) {
      let str = '';
      if (val) {
        if (val.length < 10) {
          str = val ? val : ''
        } else {
          str = val.substr(0,10) + '...'
        }
      }
      return str;
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    handleOpenPage(item,index) {
      let data = {
        ...item,
        index
      }
      this.$emit('detail',data)
    }
  }
}
</script>
<style lang="stylus" scoped>
  @import "../asset/css/commodityTb.styl"
  .commodity-tb-box {
    position:relative;
    .apply-btn {
      position: absolute;
      bottom: -20px;
      left: 18px;
    }
  }
</style>